"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userAdminPlatformActivateApi = userAdminPlatformActivateApi;
exports.userAdminPlatformCreateApi = userAdminPlatformCreateApi;
exports.userAdminPlatformDeactivateApi = userAdminPlatformDeactivateApi;
exports.userAdminPlatformHardDeleteApi = userAdminPlatformHardDeleteApi;
exports.userAdminPlatformListApi = userAdminPlatformListApi;
exports.userAdminPlatformResetPasswordApi = userAdminPlatformResetPasswordApi;
exports.userAdminPlatformSearchApi = userAdminPlatformSearchApi;
exports.userAdminPlatformSoftDeleteApi = userAdminPlatformSoftDeleteApi;
exports.userAdminPlatformSoftDeleteRestoreApi = userAdminPlatformSoftDeleteRestoreApi;
exports.userAdminPlatformSoftDeletedListApi = userAdminPlatformSoftDeletedListApi;
exports.userAdminPlatformUpdateApi = userAdminPlatformUpdateApi;
exports.userAdminPlatformValidatePasswordApi = userAdminPlatformValidatePasswordApi;
exports.userPlatformAdminDeletedByListApi = userPlatformAdminDeletedByListApi;
exports.userPlatformAdminDeletedByListTenantApi = userPlatformAdminDeletedByListTenantApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * Validate password
 * @param payload
 * @returns api response
 * @description this function used for validate Password of Platform Admin User.
 */
function userAdminPlatformValidatePasswordApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.userAdminPlatform.validatePassword), params);
}

/**
 * Search user
 * @param payload
 * @returns api response
 * @description this function used for search user of Platform User.
 */
function userAdminPlatformSearchApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.userAdminPlatform.userAdminPlatform), params);
}

/**
 * Create platform admin user
 * @param payload
 * @returns api response
 * @description this function used for create platform admin user.
 */
function userAdminPlatformCreateApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.UserService.userAdminPlatform.userAdminPlatform), params);
}

/**
 * update platform admin user
 * @param payload
 * @returns api response
 * @description this function used for update platform admin user.
 */
function userAdminPlatformUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.userAdminPlatform.userAdminPlatform), params);
}

/**
 * Hard delete platform apdmin user
 * @param payload
 * @returns api response
 * @description this function used for hard delete platform admin user.
 */
function userAdminPlatformHardDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.UserService.userAdminPlatform.hardDelete), params);
}

/**
 * Platform admin user list
 * @param payload
 * @returns api response
 * @description this function used for hard delete platform admin user.
 */
function userAdminPlatformListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.userAdminPlatform.list), params);
}

/**
 * Platform admin user reset password
 * @param payload
 * @returns api response
 * @description this function used for reset password of platform admin user.
 */
function userAdminPlatformResetPasswordApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.userAdminPlatform.resetPassword), params);
}

/**
 * Platform admin user activate
 * @param payload
 * @returns api response
 * @description this function used for activate of platform admin user.
 */
function userAdminPlatformActivateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.userAdminPlatform.activate), params);
}

/**
 * Platform admin user deactivate
 * @param payload
 * @returns api response
 * @description this function used for deactivate of platform admin user.
 */
function userAdminPlatformDeactivateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.userAdminPlatform.deactivate), params);
}

/**
 * Platform admin user soft delete
 * @param payload
 * @returns api response
 * @description this function used for sofft delete of platform admin user.
 */
function userAdminPlatformSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.UserService.userAdminPlatform.softDelete), params);
}

/**
 * Platform admin user soft delete restore
 * @param payload
 * @returns api response
 * @description this function used for sofft delete restore of platform admin user.
 */
function userAdminPlatformSoftDeleteRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.userAdminPlatform.softDeleteRestore), params);
}

/**
 * Platform admin user soft deleted list
 * @param payload
 * @returns api response
 * @description this function used for sofft deleted list of platform admin user.
 */
function userAdminPlatformSoftDeletedListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.userAdminPlatform.softDeletedList), params);
}

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function userPlatformAdminDeletedByListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.userAdminPlatform.deletedByList), params);
}

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function userPlatformAdminDeletedByListTenantApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.userAdminPlatform.deletedByListTenant), params);
}